<template>
  <luma-empty >
    <b-card class="custom-card text-center">
      <template v-slot:header>
        <h4 class="text-left">ID : {{handle.id}}</h4>
        <h1>Handle </h1>
        <b-button class="col-12 mb-4 mt-4"
                  variant="outline-success"
                  @click="edit = !edit">
          {{edit ? 'Abbrechen' : 'Bearbeiten'}}
        </b-button>
      </template>
      <h2>ALLGEMEINE INFORMATIONEN</h2>
      <br>
      <hr>
      <div v-for="(item,key) in filter.general">
        <b-form-group label-cols="4"
                      label-cols-lg="2"
                      label-size="md"
                      :label="$t('handle')[item]"
                      label-for="input-lg">

          <div v-if="item === 'dateofbirth'">
            <div v-if="!changeBirthday">
              <h4  @click="changeBirthday = !changeBirthday ">{{birthday}}  <b-link >ändern <i class="fa fa-pencil"></i></b-link> </h4>
            </div>
            <div class="datepicker" v-if="changeBirthday">
              <date-picker
                v-model="birthday"
                @input="handle.local_change = true, formatter, $forceUpdate()">
              </date-picker>
            </div>
          </div>

          <v-select v-else-if="item === 'type'"
                    v-model="handleType"
                    :clearable="false"
                    @input="handle.local_change = true"
                    :options="handleOptions">
          </v-select>
          <v-select v-else-if="item === 'sex'"
                    v-model="sex"
                    :clearable="false"
                    @input="handle.local_change = true"
                    :options="['Herr','Frau']">
          </v-select>
          <b-form-input v-else
                        id="input-lg"
                        v-model="handle[item]"
                        @input="handle.local_change = true"
                        :disabled="!edit"
                        size="lg">
          </b-form-input>
        </b-form-group>
      </div>
      <hr>
      <br>
      <h2>KONTAKT INFORMATIONEN</h2>
      <br>
      <hr>
      <div v-for="(item,key) in filter.contact">
        <b-form-group label-cols="4"
                      label-cols-lg="2"
                      label-size="md"
                      :label="$t('handle')[item]"
                      label-for="input-lg">
          <b-form-input id="input-lg"
                        @input="handle.local_change = true"
                        v-model="handle[item]"
                        :disabled="!edit"
                        size="lg">
          </b-form-input>
        </b-form-group>
      </div>
      <hr>
      <br>
      <h2>ADDRESSE</h2>
      <br>
      <hr>
      <div v-for="(item,key) in filter.address">
        <b-form-group label-cols="4"
                      label-cols-lg="2"
                      label-size="md"
                      :label="$t('handle')[item]"
                      label-for="input-lg">
          <v-select v-if="item === 'country'"
                    v-model="country"
                    @input="handle.local_change = true"
                    :clearable="false"
                    :options="countryOptions">
          </v-select>
          <b-form-input v-else
                        id="input-lg"
                        @input="handle.local_change = true"
                        v-model="handle[item]"
                        :disabled="!edit"
                        size="lg">
          </b-form-input>
        </b-form-group>
      </div>
    </b-card>
    <b-row class="fixed-bottom footer-summary" v-if="localChange === true">
      <b-col>
        <b-button class="col-12" variant="primary" @click="saveChanges()">
          <h3 v-if="!spinner">Änderungen speichern</h3>
          <b-spinner v-if="spinner"></b-spinner>
        </b-button>
      </b-col>
    </b-row>
    <b-row class="fixed-bottom footer-summary mb-0" v-if="localChange !== true && localChange !== false">
      <b-col>
        <b-link @click="handle.local_change = false"><i class="fa fa-close" ></i></b-link>
        <b-button class="col-12" variant="danger" ><h3>{{localChange}}</h3></b-button>
      </b-col>
    </b-row>
  </luma-empty>

</template>

<script>
  import {DomainHandle} from "@/store/models/domain/domain_handle"
  import DatePicker from 'v-calendar/lib/components/date-picker.umd'
  import {Country} from "@/store/models/country";
  import LumaEmpty from "../../../layout/LumaEmpty";

  export default {
      name: "luma-show-handle",

    components: {LumaEmpty, DatePicker},
    props:{
        // handleId:String,
        // handleType:String
      },
      data:()=>({
          edit:false,
        handleM:null,
          spinner:false,
          sex:null,
          country:null,
          sexDict:{'FEMALE':'Frau','MALE':'Herr'},
          birthday:'',
          changeBirthday:false
      }),

      computed:{
        handleId(){
          return this.$route.params.handle
        },
        countryC(){
            const x = Country.returnCode(this.country)
            return x
        },

        countryOptions(){
            return [...Country.vSelectOptions(),'Deutschland']
        },
        handle(){
          if(!DomainHandle.find(this.handleId)) DomainHandle.fetch(this.handleId)
          if(!this.handleM.handle) this.handleM = Object.assign({},DomainHandle.find(this.handleId))
          return this.handleM
        },
        filter(){
          if(!DomainHandle.visibleStructure) return
          const x = DomainHandle.visibleStructure
          return x
        },
        localChange(){
          return this.handle.local_change || false
        }
      },
      methods:{
        formatter(date){
            this.birthday = this.$moment(date).format('DD-MM-YYYY')
        },

        saveChanges(){
            const sendObj = Object.assign({},this.handle, {'dateofbirth':this.birthday})
            sendObj.sex = this.sex === 'Herr' ? 'MALE' : 'FEMALE'
            sendObj.country = this.countryC
            this.spinner = true
          const x = DomainHandle.editHandle(sendObj).then(
            (response)=>{
              this.handle.local_change = false
              this.spinner = false
            }
          ).catch(
            (error)=>{
              console.log('SAVE HANDLE ERROR RESPONSE::::',error)
              this.handle.local_change = error
                this.spinner = false
            }
          )

        }
      },
      created(){
        DomainHandle.fetch(this.$route.params.handle)
        this.handleM = Object.assign({},DomainHandle.find(this.$route.params.handle))
          this.sex = this.sexDict[this.handleM.sex]
          this.formatter(this.handle.dateofbirth)
          this.country = Country.returnTitle(this.handle.country)
      }
    }
</script>

<style scoped>
  .datepicker{

  }
  .custom-card{
    margin-bottom: 120px;
    margin-right: auto;
    margin-left: auto;
  }
  .footer-summary {
    margin-left: 220px;
    z-index: 1000;
    padding: 20px;
    /*height: 85px;*/
    bottom: 0px;
    background: white;
    box-shadow: 0 -1px 5px rgba(0,0,0,.2);
  }
</style>



// WEBPACK FOOTER //
// src/components/domain/handles_domain/luma-show-handle.vue